exports.components = {
  "component---src-components-templates-post-template-js": () => import("./../../../src/components/templates/post_template.js" /* webpackChunkName: "component---src-components-templates-post-template-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-upload-image-jsx": () => import("./../../../src/pages/UploadImage.jsx" /* webpackChunkName: "component---src-pages-upload-image-jsx" */)
}

